/* DT Emoji Brand: vervangt emoji's in teksten door brand-SVG iconen (was inline in snippets/dt-emoji-brand.liquid). Geladen met defer. */
(function () {
  // Map: emoji char → { icon: SVG path/element, class: brand color class }
  const SVG = {
    camera: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="13" r="3.5"/><path d="M5 7h3l2-3h4l2 3h3a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2z"/></svg>',
    film:   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="16" rx="2"/><path d="M7 4v16M17 4v16M3 8h4M3 12h4M3 16h4M17 8h4M17 12h4M17 16h4"/></svg>',
    flame:  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.4-.5-2-1-3-1-2-.2-4 2-6 .5 2.5 2 5 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.2.4-2.3 1-3a2.5 2.5 0 0 0 2.5 2.5z"/></svg>',
    check:  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>',
    star:   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 15.1 8.5 22 9.3 17 14 18.2 21 12 17.8 5.8 21 7 14 2 9.3 8.9 8.5 12 2"/></svg>',
    starF:  '<svg viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1" stroke-linejoin="round"><polygon points="12 2 15.1 8.5 22 9.3 17 14 18.2 21 12 17.8 5.8 21 7 14 2 9.3 8.9 8.5 12 2"/></svg>',
    bulb:   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18h6M10 22h4M12 2a7 7 0 0 1 4 12.7c-.6.4-1 1-1 1.8V18H9v-1.5c0-.8-.4-1.4-1-1.8A7 7 0 0 1 12 2z"/></svg>',
    box:    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M21 8v13H3V8M1 3h22v5H1z"/><path d="M10 12h4"/></svg>',
    truck:  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="6" width="14" height="12" rx="1"/><polygon points="15 9 19 9 22 13 22 18 15 18 15 9"/><circle cx="6" cy="20" r="2"/><circle cx="18" cy="20" r="2"/></svg>',
    heart:  '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 21s-7-4.5-9.5-9C.7 8.7 2.1 5 5.5 5c2 0 3.5 1 4.5 2.5C11 6 12.5 5 14.5 5c3.4 0 4.8 3.7 3 7-2.5 4.5-9.5 9-9.5 9z"/></svg>',
    bolt:   '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M13 2L4 14h7l-1 8 9-12h-7l1-8z"/></svg>',
    target: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="5"/><circle cx="12" cy="12" r="1.5" fill="currentColor"/></svg>',
    eye:    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>',
    globe:  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="12" r="9"/><path d="M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18"/></svg>',
    clapper:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9h18v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9z"/><path d="M3 9l2-5h14l2 5M8 4l-1 5M14 4l-1 5"/></svg>',
    diamond:'<svg viewBox="0 0 24 24" fill="currentColor"><path d="M6 3h12l4 6-10 12L2 9l4-6z"/></svg>',
    tag:    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M20.6 13.4l-7.2 7.2a2 2 0 0 1-2.8 0L2 12V2h10l8.6 8.6a2 2 0 0 1 0 2.8z"/><circle cx="7.5" cy="7.5" r="1.5" fill="currentColor"/></svg>',
    shield: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>',
    lock:   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>',
    gift:   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="8" width="20" height="14" rx="2"/><path d="M12 8v14M2 13h20M16 8a3 3 0 0 0-4-3 3 3 0 0 0-4 3c0 0 4 0 4 0s4 0 4 0z"/></svg>',
    sparkle:'<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l1.5 5.5L19 9l-5.5 1.5L12 16l-1.5-5.5L5 9l5.5-1.5L12 2zM19 14l.8 2.7L22 18l-2.2 1.3L19 22l-.8-2.7L16 18l2.2-1.3L19 14z"/></svg>',
    gear:   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1.1-1.5 1.7 1.7 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.5-1.1 1.7 1.7 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.8.3H9a1.7 1.7 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.8V9a1.7 1.7 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z"/></svg>',
    pin:    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s-7-7-7-12a7 7 0 1 1 14 0c0 5-7 12-7 12z"/><circle cx="12" cy="10" r="2.5"/></svg>',
    key:    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="8" cy="15" r="4"/><path d="M11 12l9-9M16 7l3 3M14 9l3 3"/></svg>',
    info:   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 8h.01M11 12h1v5h1"/></svg>',
    warn:   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z"/><path d="M12 9v4M12 17h.01"/></svg>',
    list:   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01"/></svg>',
    clock:  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><polyline points="12 7 12 12 15 14"/></svg>',
    euro:   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M18 7a7 7 0 1 0 0 10M4 11h10M4 14h10"/></svg>',
    hand:   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M18 11V6a2 2 0 1 0-4 0v5M14 10V4a2 2 0 1 0-4 0v8M10 10V5a2 2 0 1 0-4 0v9M18 8a2 2 0 1 1 4 0v6a8 8 0 0 1-8 8h-2a8 8 0 0 1-8-8v-1l3 .5"/></svg>',
    tools:  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M14.7 6.3a4 4 0 0 1 5.7 5.7l-1.4 1.4a1 1 0 0 1-1.4 0L13.3 9a1 1 0 0 1 0-1.4l1.4-1.3z"/><path d="M2 22l7-7M5 19l4 4M16 14l5 5"/></svg>'
  };

  // Emoji unicode → SVG icon + brand color class
  const MAP = {
    '📷': { svg: SVG.camera,  cls: 'dt-emoji--accent' },
    '📸': { svg: SVG.camera,  cls: 'dt-emoji--accent' },
    '📹': { svg: SVG.clapper, cls: 'dt-emoji--accent' },
    '🎥': { svg: SVG.clapper, cls: 'dt-emoji--accent' },
    '🎞️': { svg: SVG.film,    cls: 'dt-emoji--text' },
    '🎞': { svg: SVG.film,    cls: 'dt-emoji--text' },
    '🎬': { svg: SVG.clapper, cls: 'dt-emoji--text' },
    '🔥': { svg: SVG.flame,   cls: 'dt-emoji--orange' },
    '✅': { svg: SVG.check,   cls: 'dt-emoji--green' },
    '☑️': { svg: SVG.check,   cls: 'dt-emoji--green' },
    '✔️': { svg: SVG.check,   cls: 'dt-emoji--green' },
    '✓':  { svg: SVG.check,   cls: 'dt-emoji--green' },
    '⭐': { svg: SVG.starF,   cls: 'dt-emoji--yellow' },
    '🌟': { svg: SVG.starF,   cls: 'dt-emoji--yellow' },
    '✨': { svg: SVG.sparkle, cls: 'dt-emoji--yellow' },
    '💫': { svg: SVG.sparkle, cls: 'dt-emoji--yellow' },
    '💡': { svg: SVG.bulb,    cls: 'dt-emoji--yellow' },
    '📦': { svg: SVG.box,     cls: 'dt-emoji--text' },
    '🚚': { svg: SVG.truck,   cls: 'dt-emoji--accent' },
    '🛒': { svg: SVG.box,     cls: 'dt-emoji--accent' },
    '❤️': { svg: SVG.heart,   cls: 'dt-emoji--red' },
    '❤':  { svg: SVG.heart,   cls: 'dt-emoji--red' },
    '🧡': { svg: SVG.heart,   cls: 'dt-emoji--orange' },
    '💛': { svg: SVG.heart,   cls: 'dt-emoji--yellow' },
    '⚡': { svg: SVG.bolt,    cls: 'dt-emoji--yellow' },
    '🎯': { svg: SVG.target,  cls: 'dt-emoji--accent' },
    '👀': { svg: SVG.eye,     cls: 'dt-emoji--accent' },
    '👁️': { svg: SVG.eye,     cls: 'dt-emoji--accent' },
    '🌍': { svg: SVG.globe,   cls: 'dt-emoji--accent' },
    '🌎': { svg: SVG.globe,   cls: 'dt-emoji--accent' },
    '🌐': { svg: SVG.globe,   cls: 'dt-emoji--accent' },
    '💎': { svg: SVG.diamond, cls: 'dt-emoji--accent' },
    '🏷️': { svg: SVG.tag,     cls: 'dt-emoji--accent' },
    '🛡️': { svg: SVG.shield,  cls: 'dt-emoji--green' },
    '🔒': { svg: SVG.lock,    cls: 'dt-emoji--text' },
    '🎁': { svg: SVG.gift,    cls: 'dt-emoji--accent' },
    '⚙️': { svg: SVG.gear,    cls: 'dt-emoji--text' },
    '⚙':  { svg: SVG.gear,    cls: 'dt-emoji--text' },
    '🔧': { svg: SVG.tools,   cls: 'dt-emoji--text' },
    '🛠️': { svg: SVG.tools,   cls: 'dt-emoji--text' },
    '📌': { svg: SVG.pin,     cls: 'dt-emoji--red' },
    '📍': { svg: SVG.pin,     cls: 'dt-emoji--red' },
    '🔑': { svg: SVG.key,     cls: 'dt-emoji--yellow' },
    '🗝️': { svg: SVG.key,     cls: 'dt-emoji--yellow' },
    'ℹ️': { svg: SVG.info,    cls: 'dt-emoji--blue' },
    '⚠️': { svg: SVG.warn,    cls: 'dt-emoji--orange' },
    '⚠':  { svg: SVG.warn,    cls: 'dt-emoji--orange' },
    '📝': { svg: SVG.list,    cls: 'dt-emoji--text' },
    '📋': { svg: SVG.list,    cls: 'dt-emoji--text' },
    '⏰': { svg: SVG.clock,   cls: 'dt-emoji--accent' },
    '⏱️': { svg: SVG.clock,   cls: 'dt-emoji--accent' },
    '🕐': { svg: SVG.clock,   cls: 'dt-emoji--accent' },
    '💰': { svg: SVG.euro,    cls: 'dt-emoji--green' },
    '💶': { svg: SVG.euro,    cls: 'dt-emoji--green' },
    '💵': { svg: SVG.euro,    cls: 'dt-emoji--green' },
    '🤝': { svg: SVG.hand,    cls: 'dt-emoji--accent' },
    '👍': { svg: SVG.check,   cls: 'dt-emoji--green' },
    '✋': { svg: SVG.hand,    cls: 'dt-emoji--accent' }
  };

  // Emoji regex — Unicode property class (modern browsers)
  let EMOJI_RE;
  try {
    EMOJI_RE = new RegExp('(\\p{Extended_Pictographic}(\\uFE0F)?)', 'gu');
  } catch (e) {
    // Fallback for older browsers — basic emoji ranges
    EMOJI_RE = /([\u{1F300}-\u{1FAFF}\u{2600}-\u{27BF}](️)?)/gu;
  }

  function replaceInTextNode(node) {
    const text = node.nodeValue;
    if (!text) return;
    // Reset regex state — vital bij globale /g flag tussen text nodes
    EMOJI_RE.lastIndex = 0;
    if (!EMOJI_RE.test(text)) return;
    EMOJI_RE.lastIndex = 0;

    const frag = document.createDocumentFragment();
    let lastIdx = 0;
    let match;
    while ((match = EMOJI_RE.exec(text)) !== null) {
      const emoji = match[0];
      const start = match.index;
      if (start > lastIdx) {
        frag.appendChild(document.createTextNode(text.slice(lastIdx, start)));
      }
      const mapped = MAP[emoji] || MAP[emoji.replace('️', '')];
      if (mapped) {
        const span = document.createElement('span');
        span.className = 'dt-emoji ' + mapped.cls;
        span.setAttribute('role', 'img');
        span.setAttribute('aria-hidden', 'true');
        span.innerHTML = mapped.svg;
        frag.appendChild(span);
      } else {
        // Fallback: muted brand-friendly raw emoji
        const span = document.createElement('span');
        span.className = 'dt-emoji-raw';
        span.setAttribute('role', 'img');
        span.setAttribute('aria-hidden', 'true');
        span.textContent = emoji;
        frag.appendChild(span);
      }
      lastIdx = start + emoji.length;
    }
    if (lastIdx < text.length) {
      frag.appendChild(document.createTextNode(text.slice(lastIdx)));
    }
    node.parentNode.replaceChild(frag, node);
  }

  function walk(root) {
    if (!root) return;
    // Don't double-process
    if (root.querySelector && root.querySelector('.dt-emoji, .dt-emoji-raw')) {
      return;
    }
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        // Skip text inside script/style/our own spans
        const p = n.parentNode;
        if (!p) return NodeFilter.FILTER_REJECT;
        const tag = (p.tagName || '').toLowerCase();
        if (tag === 'script' || tag === 'style' || tag === 'textarea') return NodeFilter.FILTER_REJECT;
        if (p.classList && (p.classList.contains('dt-emoji') || p.classList.contains('dt-emoji-raw'))) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });

    const nodes = [];
    let n;
    while ((n = walker.nextNode())) nodes.push(n);
    nodes.forEach(replaceInTextNode);
  }

  // Target: product descriptions, blog content, dt-story body, accordion tabs
  const SELECTORS = [
    '.rte',
    '.product-description',
    '.product__description',
    '.product__description-content',
    '.dt-desc-tabs__content',
    '.dt-tabs',
    '.dt-tabs__pre',
    '.dt-tabs__title',
    '.dt-tabs__body',
    '.dt-tabs__panel',
    '.dt-story__body',
    '.article-template__content',
    '.accordion',
    '[class*="product-description"]',
    '[class*="page-content"]',
    '[class*="text-block"]'
  ];

  function run() {
    SELECTORS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(walk);
    });
    document.documentElement.classList.add('dt-emoji-ready');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
  // Safety net — toon containers ook als JS faalt of selectors niets vinden
  setTimeout(function () {
    document.documentElement.classList.add('dt-emoji-timeout');
  }, 600);
  // Run once more after late content loads (accordions etc.)
  setTimeout(run, 2000);
})();
